<!--  -->
<template>
  <div>
    <!-- 语言选择 -->
    <el-dialog title="请选择" :visible.sync="dialogVisible" width="15%" :close-on-click-modal='false' >
  <el-radio-group  @change="handleRadioChange" v-model="selected">
    <el-radio  label="FT">繁体中文</el-radio>
  <el-radio  label="RY" style="margin-left:20px">日语</el-radio>
  </el-radio-group>
    
     
      </el-dialog>
    <!-- header 导航栏 -->
    <div class="nav">
      <div
        style="
          width: 233px;
          height: 80px;

          display: flex;
          flex-direction: column;
          justify-content: center;
        "
      >
        <div style="display: flex; align-items: center">
          <img
            src="../assets/香港首页繁体_slices/博爱logo.png"
            alt=""
            style="width: 42px; height: 41px"
          />
          <img
            src="../assets/香港首页繁体_slices/博爱香港有限公司(1).png"
            alt=""
            style="height: 17px; margin-left: 15px"
          />
        </div>
        <!-- <div
          style="
            margin-left: 10px;
            font-weight: 400;
            color: #fff;
            font-size: 20px;
          "
        >
          博爱医药
        </div> -->
      </div>
      <div>
        <ul class="center">
          <li @click="btnClick(1)">
            <a :class="{ active: itemIndex == 1 }">首頁</a> |
          </li>
          <li>
            <a :class="{ active: itemIndex == 2 }" @click="btnClick(2)"
              >關于我們</a
            >
            |
          </li>
          <li @click="btnClick(3)">
            <a :class="{ active: itemIndex == 3 }">人才招聘</a> |
          </li>
          <li @click="btnClick(4)">
            <a :class="{ active: itemIndex == 4 }">聯系我們</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 1是首页  2是关于我们 3是会员服务 4是博爱大事记 5是供应商平台 6是人才招聘-->
    <div v-if="this.itemIndex == 1">
      <!-- banner -->
      <div class="top-rowBanner"></div>

      <!-- 会社案内 -->
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          padding: 100px 0;
        "
      >
        <!-- left -->
        <div
          style="
            width: 1000px;
            height: 259px;
            display: flex;
            justify-content:space-between
          
            border:1px solid red
          "
        >
          <!-- right -->
          <div>
            <div>
              <img
                src="../assets/第一生命首页繁体_slices/公司简介.png"
                alt=""
                style="width: 115px; height: 27px"
              />
              <img
                src="../assets/香港首页繁体_slices/Company Profile.png"
                alt=""
                style="margin-left: 20px; height: 13px"
              />
            </div>
            <div style="margin-top: 20px; color: #246ef6"><B>_______</B></div>
            <div>
              <img
                src="../assets/香港首页繁体_slices/营口博爱医药连锁有限公司坐落于辽宁省营口市，是一家集零售、批发与电商于一体的综合性医药企业，覆盖线下连锁+线上B2C电商+批发.png"
                alt=""
                style="margin-top: 40px; height: 225px; width: 660px"
              />
            </div>
          </div>
          <!-- left -->
          <div>
            <img
              src="../assets/香港首页繁体_slices/banner1.png"
              alt=""
              style="width: 300px; height: 500px"
            />
          </div>
        </div>
      </div>

      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 1000px;
          "
        >
          <div
            style="
              width: 1000px;
              display: flex;
              justify-content: center;
              align-items:end
              color: #0762cb;

            margin-top:100px
            "
          >
            <img
              src="../assets/香港首页繁体_slices/中国总公司.png"
              alt=""
              style="width: 135px; height: 27px"
            />
          </div>
        </div>
        <div style="color: #246ef6"><B>_______</B></div>
        <div style="margin-top: 20px">
          <img
            src="../assets/香港首页繁体_slices/head office.png"
            alt=""
            style="width: 130px; height: 13px; margin-left: 15px"
          />
        </div>
        <div
          style="
            width: 1000px;
            height: 259px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 45px;
            /* border:1px solid red */
          "
        >
          <img
            src="../assets/1.jpg"
            alt=""
            style="width: 320px; height: 220px"
          />
          <img
            src="../assets/2.jpg"
            alt=""
            style="width: 320px; height: 220px"
          />
          <img
            src="../assets/3jpg.jpg"
            alt=""
            style="width: 320px; height: 220px"
          />
        </div>
        <div
          style="
            width: 1000px;
            height: 259px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 1px;
            /* border:1px solid red */
          "
        >
          <img
            src="../assets/首页_slices/图层 20.png"
            alt=""
            style="width: 320px; height: 220px"
          />
          <img
            src="../assets/首页_slices/图层 22.png"
            alt=""
            style="width: 320px; height: 220px"
          />
          <img
            src="../assets/首页_slices/图层 23.png"
            alt=""
            style="width: 320px; height: 220px"
          />
        </div>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 1000px;
          "
        >
          <div
            style="
              width: 1000px;
              display: flex;
              justify-content: center;
              align-items:end
              color: #0762cb;

            margin-top:100px
            "
          >
            <img
              src="../assets/香港首页繁体_slices/八大优势.png"
              alt=""
              style="width: 135px; height: 27px"
            />
          </div>
        </div>
        <div style="color: #246ef6"><B>_______</B></div>
        <div style="margin-top: 20px">
          <img
            src="../assets/香港首页繁体_slices/够健康 够快乐.png"
            alt=""
            style="width: 140px; height: 20px; margin-left: 7px"
          />
        </div>
        <div
          style="
            width: 1000px;

            display: flex;

            align-items: center;

            margin-top: 30px;
            justify-content: space-between;
            /* border:1px solid red */
          "
        >
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 120px;
              width: 300px;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 70px;
                height: 70px;
                border-radius: 40px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/1.png"
                alt=""
                style="width: 39px"
              />
            </div>

            <img
              src="../assets/香港首页繁体_slices/国家认证 资质齐全.png"
              alt=""
              style="width: 120px"
            />
          </div>

          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 120px;
              width: 300px;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 70px;
                height: 70px;
                border-radius: 40px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/2.png"
                alt=""
                style="width: 39px"
              />
            </div>

            <img
              src="../assets/香港首页繁体_slices/药企直采 正品保证.png"
              alt=""
              style="width: 120px"
            />
          </div>

          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 120px;
              width: 300px;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 70px;
                height: 70px;
                border-radius: 40px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/3.png"
                alt=""
                style="width: 39px"
              />
            </div>

            <img
              src="../assets/香港首页繁体_slices/职业药师 在线咨询.png"
              alt=""
              style="width: 120px"
            />
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 120px;
              width: 300px;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 70px;
                height: 70px;
                border-radius: 40px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/4.png"
                alt=""
                style="width: 39px"
              />
            </div>

            <img
              src="../assets/香港首页繁体_slices/隐私配送 无忧用药.png"
              alt=""
              style="width: 120px"
            />
          </div>
        </div>
        <div
          style="
            width: 1000px;

            display: flex;

            align-items: center;

            margin-top: 30px;
            justify-content: space-between;
            /* border:1px solid red */
          "
        >
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 250px;
                height: 370px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/1-1.png"
                alt=""
                style="width: 69px"
              />
              <img
                src="../assets/香港首页繁体_slices/实力保障 多家线下门店.png"
                alt=""
                style="width: 120px; margin-top: 15px"
              />
            </div>
          </div>

          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 249px;
                height: 370px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/2-2.png"
                alt=""
                style="width: 69px"
              />
              <img
                src="../assets/香港首页繁体_slices/药品种类齐全.png"
                alt=""
                style="width: 120px; margin-top: 15px"
              />
            </div>
          </div>

          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 249px;
                height: 370px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/3-3.png"
                alt=""
                style="width: 69px"
              />
              <img
                src="../assets/香港首页繁体_slices/网上商城 在线下单更方便.png"
                alt=""
                style="width: 120px; margin-top: 15px"
              />
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 249px;
                height: 370px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/4-4.png"
                alt=""
                style="width: 69px"
              />
              <img
                src="../assets/香港首页繁体_slices/医疗咨询 各种各样的保障.png"
                alt=""
                style="width: 120px; margin-top: 15px"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 1000px;
          "
        >
          <div
            style="
              width: 1000px;
              display: flex;
              justify-content: center;
              align-items:end
              color: #0762cb;

            margin-top:100px
            "
          >
            <img
              src="../assets/香港首页繁体_slices/服务项目.png"
              alt=""
              style="width: 135px; height: 27px"
            />
          </div>
        </div>
        <div style="color: #246ef6"><B>_______</B></div>
        <div style="margin-top: 20px">
          <img
            src="../assets/香港首页繁体_slices/Service Items.png"
            alt=""
            style="width: 140px; height: 15px; margin-left: 7px"
          />
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img src="../assets/繁体.png" alt="" style="width: 1000px" />
        </div>
      </div>
      <!-- footer -->
      <div
        class="footerBanner"
        style="
          width: 100%;
          height: 300px;

          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 100px;
        "
      >
        <div
          style="
            width: 1000px;
            height: 280px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div style="width:1000px;height:270px;background-color:rgba(254,254,254,0.65);margin-top:30px;display:flex">
         <div>
             <!-- 1 -->
             <div style="display: flex; align-items: center;margin-left:45px;margin-top:25px">
              <img
                src="../assets/香港首页繁体_slices/博爱logo.png"
                alt=""
                style="width:35px; height:32px"
              />
              <img
                src="../assets/香港首页繁体_slices/博爱香港有限公司(1).png"
                alt=""
                style="height: 17px; margin-left: 15px"
              />
            </div>
            <!-- 2 -->
            <div>
              <img src="../assets/香港首页繁体_slices/微笑面对每一位顾客，诚恳服务每一位顾客，从小事做起、从细节着手，用热心和耐心温暖顾客； 用诚心和爱心感动顾客；用心、尽心奉献于.png" alt="" style="width:560px;margin-left:45px;margin-top:28px">
            </div>
            <!-- 3 -->
            <div>
              <img src="../assets/香港首页繁体_slices/中国总公司： 营口博爱医药连锁有限公司：http：／／www.boaiyiyao.com  日本分公司： 株式会社政轩：htt.png" alt="" style="width:320px;margin-left:45px;margin-top:28px" >
            </div>
         </div>
         <div style="margin-left:240px;margin-top:115px;display:flex;align-items:center;flex-direction:column">
          <img src="../assets/香港首页繁体_slices/图层 19.png" alt="">
          <img src="../assets/香港首页繁体_slices/博爱公众号.png" alt="">
         </div>
          </div>
        </div>
      </div>
      <div style="width:100%;height:60px;background:#2C445C;display:flex;justify-content:center;align-items:center">
          <div style="width:1000px;height:40px;display:flex;align-items:center;justify-content:space-around;color:white">
          <div>首頁</div>
          <div>關于我們</div>
          <div>人才招聘</div>
          <div>聯系我們</div>
          </div>
      </div>
    </div>
    <div v-if="this.itemIndex == 2">
      <!-- banner -->
      <div class="top-rowBanner1111">
        <div style="margin-left:45%">
          <div><img src="../assets/第一生命关于我们繁体_slices/About Us.png" alt="" style="width:200px;margin-top:200px"></div>
        <div>
          <img src="../assets/第一生命关于我们繁体_slices/关于我们.png" alt="" style="width:100px;margin-left:50px;margin-top:10px">
        </div>
        </div>
      </div>

      <!-- 医院环境 -->
      <div style="display: flex; justify-content: center">
        <div
          style="
            display: flex;
            justify-content:space-between;
            width: 1000px;
          
            height: 500px;
            margin-top:150px
          "
        >
        <!-- left -->
      <div style="width:390px;height:200px;background:white;">
    <img src="../assets/香港关于我们_slices/矩形 13 拷贝.png" alt="" style="width:480px;height:290px;position: absolute;z-index:998;margin-top:168px;">

   <div >
    <div>
      <div style="width:3px;height:15px;background:#0762CB;position: relative;top:220px;left:60px;z-index:999;" ></div>
      <div style="position: relative;top:204px;left:70px;z-index:999;"><img src="../assets/第一生命首页繁体_slices/公司简介.png" alt="" style="height:25px"></div>
      <div style="position: relative;top:186px;left:184px;z-index:999;"><img src="../assets/香港关于我们_slices/Company Profile.png" alt="" style="height:12px"></div>
    </div>
    <div style="position: relative;top:192px;left:58px;z-index:999;font-size:12px;width:370px;letter-spacing:1.5px;color:grey">
    
    &nbsp;&nbsp;&nbsp;&nbsp;營口博愛醫藥連鎖有限公司坐落於遼寧省營口市，是一家集零售、批發與電商於一體的綜合性醫藥企業，覆蓋線下連鎖+線上B2C電商+批發業務公司旗下擁有連鎖門店120家;線上則覆蓋了天貓(博愛大藥房旗艦店、元沛堂大藥房旗艦店)及京東、拼多多等平臺合計銷售額8000萬元/年，其中天貓5000萬元。此外，公司還運營著醫藥批發企業--遼寧格列安醫藥股份有限公司，專註於全國範圍內的醫藥批發業務，年銷售額高達5億元。公司總員工數達480人，確保高效運營與持續創新。23年布局跨境OTC領域目前註冊香港、日本兩家境外公司進行進口業務。



    </div>
   </div>
      </div>
      <!-- right -->
      <div style="width:800px;height:350px;position: relative;right:170px">
      <img src="../assets/香港关于我们_slices/1.png" alt="" style="width:800px;height:350px;">
      </div>
        </div>

      </div>

      <div style="display: flex; justify-content: center">
        <div
          style="
            display: flex;
            justify-content:space-between;
            width: 1000px;
    
            height: 500px;
            margin-top:10px
          "
        >
        <!-- left -->
      <div style="width:390px;height:200px;background:white;">
    <img src="../assets/香港关于我们_slices/2.png" alt="" style="width:300px;height:370px;position: absolute;z-index:998;margin-top:88px;">


      </div>
      <!-- right -->
      <div style="width:2700px;height:458px;position: relative;background:#EEF2F6;">
<div style="display:flex;margin-left:230px;margin-top:150px">
  <div style="width:3px;height:15px;background:#0762CB;" ></div>
      <div style=""><img src="../assets/第一生命关于我们繁体_slices/产品规划及优势.png" alt="" style="height:25px;margin-left:10px;"></div>
</div>
      <div style=""><img src="../assets/香港关于我们_slices/Mission Vision.png" alt="" style="height:12px;margin-left:300px;width:130px;margin-left:244px;margin-top:10px"></div>
   <div  style="height:12px;margin-left:300px;width:530px;margin-left:244px;margin-top:10px;letter-spacing:1.5px;color:grey;font-size:12px">
    ①香港、日本及澳洲流通藥品、保健品、醫療器械:可利用博愛現有門店進行銷售地推 提供掃碼下單郵寄到家服務(按平均單店銷售200元/日計算 全年可產生800萬保底銷售額)同時促進線上銷售

  </div>
  <div  style="height:12px;margin-left:300px;width:530px;margin-left:244px;margin-top:60px;letter-spacing:1.5px;color:grey;font-size:12px">②獨家產品與定製規格:依托國內公司影響力，與同仁堂、馬應龍、廣譽遠、九芝堂等老字號品牌深度合作，推出出口規格回流產品及國內市場獨家定製產品(如港版安宮牛黃丸三丸、港版驢膠補血顆粒等)</div>
  <div  style="height:12px;margin-left:300px;width:530px;margin-left:244px;margin-top:60px;letter-spacing:1.5px;color:grey;font-size:12px">
③日版漢方中藥:借助日本公司資源，生產獨家規格日版漢方中藥(如八位地黃丸、六君子湯等)</div>
      </div>
        </div>

      </div>
      <div style="display:flex;justify-content:center;align-items:center">
      <div style="width:1000px;display:flex;align-items:center;margin-left:30px">
        <div style="width:3px;height:15px;background:#0762CB;" ></div>
      <div style=""><img src="../assets/第一生命关于我们繁体_slices/运营优势.png" alt="" style="height:25px;margin-top:10px;margin-left:5px"></div>
      <div style=""><img src="../assets/香港关于我们_slices/Mission Vision.png" alt="" style="height:12px;margin-left:5px;margin-top:15px;"></div>
      </div>

    
    </div>
    <div style="display:flex;justify-content:center;align-items:center">
      <div style="width:1000px;display:flex;justify-content:space-between">
        <div style="position:relative">
          <img src="../assets/香港关于我们_slices/矩形 18 拷贝.png" alt="" style="width:330px;height:400px;">
         
          <img src="../assets/香港关于我们_slices/3.png" alt="" style="width:268px;position:absolute;top:28px;left:30px;height:200px">
          <div style="position:absolute;top:193px;left:60px;width:60px;height:60px;border-radius:50%;background:#246EF6;display:flex;justify-content:center;align-items:center">
          <img src="../assets/香港关于我们_slices/1-1.png" alt="" style="width:37px;height:27px">
          </div>
          <div  style="position:absolute;top:263px;left:50px;width:230px;height:60px;font-size:12px;color:grey">
            <img src="../assets/香港关于我们_slices/专业电商团队.png" alt="" style="width:100px;">
          </div>
          <div  style="position:absolute;top:288px;left:50px;width:230px;height:60px;font-size:12px;color:grey">
            60人規模的電商運營團隊，具備豐富的國內醫藥電商運營經驗。
          </div>
        </div>
  
        <div style="position:relative">
          <img src="../assets/香港关于我们_slices/矩形 18 拷贝.png" alt="" style="width:330px;height:400px;">
    
          <img src="../assets/香港关于我们_slices/4.png" alt="" style="width:268px;position:absolute;top:28px;left:30px;height:200px">
          <div style="position:absolute;top:193px;left:60px;width:60px;height:60px;border-radius:50%;background:#246EF6;display:flex;justify-content:center;align-items:center">
          <img src="../assets/香港关于我们_slices/2-2.png" alt="" style="width:30px;height:30px">
          </div>
          <div  style="position:absolute;top:263px;left:50px;width:230px;height:60px;font-size:12px;color:grey">
            <img src="../assets/香港关于我们_slices/全球采购与物流.png" alt="" style="width:100px;">
          </div>
          <div style="position:absolute;top:288px;left:50px;width:230px;height:60px;font-size:12px;color:grey">
            在香港和日本設有常駐采購人員，有效降低采購成本，同時配物流運輸體系，確保產品供應穩定與快速響應市場需求。

          </div>
        </div>
        <div style="position:relative">
          <img src="../assets/香港关于我们_slices/矩形 18 拷贝.png" alt="" style="width:330px;height:400px;">
   
          <img src="../assets/香港关于我们_slices/5.png" alt="" style="width:268px;position:absolute;top:28px;left:30px;height:200px">
          <div style="position:absolute;top:193px;left:60px;width:60px;height:60px;border-radius:50%;background:#246EF6;display:flex;justify-content:center;align-items:center">
          <img src="../assets/香港关于我们_slices/3-3.png" alt="" style="width:35px;height:27px">
          </div>
          <div  style="position:absolute;top:263px;left:50px;width:230px;height:60px;font-size:12px;color:grey">
            <img src="../assets/香港关于我们_slices/采用线下连锁店.png" alt="" style="width:100px;">
          </div>
          <div style="position:absolute;top:288px;left:50px;width:230px;height:60px;font-size:12px;color:grey">
            采用線下連鎖店，進行國際店鋪推廣。

          </div>
        </div>


</div>
    </div>
  <!-- footer -->
  <div
        class="footerBanner"
        style="
          width: 100%;
          height: 300px;

          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 100px;
        "
      >
        <div
          style="
            width: 1000px;
            height: 280px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div style="width:1000px;height:270px;background-color:rgba(254,254,254,0.65);margin-top:30px;display:flex">
         <div>
             <!-- 1 -->
             <div style="display: flex; align-items: center;margin-left:45px;margin-top:25px">
              <img
                src="../assets/香港首页繁体_slices/博爱logo.png"
                alt=""
                style="width:35px; height:32px"
              />
              <img
                src="../assets/香港首页繁体_slices/博爱香港有限公司(1).png"
                alt=""
                style="height: 17px; margin-left: 15px"
              />
            </div>
            <!-- 2 -->
            <div>
              <img src="../assets/香港首页繁体_slices/微笑面对每一位顾客，诚恳服务每一位顾客，从小事做起、从细节着手，用热心和耐心温暖顾客； 用诚心和爱心感动顾客；用心、尽心奉献于.png" alt="" style="width:560px;margin-left:45px;margin-top:28px">
            </div>
            <!-- 3 -->
            <div>
              <img src="../assets/香港首页繁体_slices/中国总公司： 营口博爱医药连锁有限公司：http：／／www.boaiyiyao.com  日本分公司： 株式会社政轩：htt.png" alt="" style="width:320px;margin-left:45px;margin-top:28px" >
            </div>
         </div>
         <div style="margin-left:240px;margin-top:115px;display:flex;align-items:center;flex-direction:column">
          <img src="../assets/香港首页繁体_slices/图层 19.png" alt="">
          <img src="../assets/香港首页繁体_slices/博爱公众号.png" alt="">
         </div>
          </div>
        </div>
      </div>
      <div style="width:100%;height:60px;background:#2C445C;display:flex;justify-content:center;align-items:center">
          <div style="width:1000px;height:40px;display:flex;align-items:center;justify-content:space-around;color:white">
          <div>首頁</div>
          <div>關于我們</div>
          <div>人才招聘</div>
          <div>聯系我們</div>
          </div>
      </div>
    </div>
    <div v-if="this.itemIndex == 4">
      <!-- banner -->
      <div class="top-rowBanner222222">
        <div style="margin-left:45%">
          <div><img src="../assets/第一生命关于我们繁体_slices/Contact Us.png" alt="" style="width:200px;margin-top:200px"></div>
        <div>
          <img src="../assets/第一生命关于我们繁体_slices/联系我们.png" alt="" style="width:100px;margin-left:50px;margin-top:10px">
        </div>
        </div>
      </div>
      <!-- 关于博爱 -->

      <!-- 四大优势 -->
<div style="display:flex;justify-content:center;align-items:center">
<div style="width:1000px;height:290px;margin-top:60px" class="contentUS"> 
<!-- <img src="../assets/lxwm1.png" alt="" style="width:1000px;height:290px;position: relative;"> -->
<img src="../assets/联系我们_slices/Contact.png" alt="" style="width:120px;margin-left:50px;margin-top:25px">
<div style="width:270px;margin-left:50px;margin-top:15px">博愛香港有限公司（博愛大藥房）</div>
<div style="margin-left:50px;margin-top:25px;width:270px"><b>______</b></div>
<div style="margin-left:50px;margin-top:45px;width:570px;letter-spacing:1.5px">TEL ：18141702222</div>
<div style="margin-left:50px;margin-top:10px;width:570px;letter-spacing:1.5px">地址 ：荃灣半山街10-16號富華工業大廈7/F樓B座(肆拾柒)室</div>
<div style="margin-left:50px;margin-top:10px;width:270px;letter-spacing:1.5px;">沒有顧客的不對，只有我們的不足</div>

</div>
</div>
  

   <!-- footer -->
   <div
        class="footerBanner"
        style="
          width: 100%;
          height: 300px;

          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 60px;
        "
      >
        <div
          style="
            width: 1000px;
            height: 280px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div style="width:1000px;height:270px;background-color:rgba(254,254,254,0.65);margin-top:30px;display:flex">
         <div>
             <!-- 1 -->
             <div style="display: flex; align-items: center;margin-left:45px;margin-top:25px">
              <img
                src="../assets/香港首页繁体_slices/博爱logo.png"
                alt=""
                style="width:35px; height:32px"
              />
              <img
                src="../assets/香港首页繁体_slices/博爱香港有限公司(1).png"
                alt=""
                style="height: 17px; margin-left: 15px"
              />
            </div>
            <!-- 2 -->
            <div>
              <img src="../assets/香港首页繁体_slices/微笑面对每一位顾客，诚恳服务每一位顾客，从小事做起、从细节着手，用热心和耐心温暖顾客； 用诚心和爱心感动顾客；用心、尽心奉献于.png" alt="" style="width:560px;margin-left:45px;margin-top:28px">
            </div>
            <!-- 3 -->
            <div>
              <img src="../assets/香港首页繁体_slices/中国总公司： 营口博爱医药连锁有限公司：http：／／www.boaiyiyao.com  日本分公司： 株式会社政轩：htt.png" alt="" style="width:320px;margin-left:45px;margin-top:28px" >
            </div>
         </div>
         <div style="margin-left:240px;margin-top:115px;display:flex;align-items:center;flex-direction:column">
          <img src="../assets/香港首页繁体_slices/图层 19.png" alt="">
          <img src="../assets/香港首页繁体_slices/博爱公众号.png" alt="">
         </div>
          </div>
        </div>
      </div>
      <div style="width:100%;height:60px;background:#2C445C;display:flex;justify-content:center;align-items:center">
          <div style="width:1000px;height:40px;display:flex;align-items:center;justify-content:space-around;color:white">
          <div>首頁</div>
          <div>關于我們</div>
          <div>人才招聘</div>
          <div>聯系我們</div>
          </div>
      </div>
    </div>
    <div v-if="this.itemIndex == 3">
      <div class="top-rowBanner444444">
        <div style="margin-left:45%">
          <div><img src="../assets/第一生命关于我们繁体_slices/Talent Recruitment@3x.png" alt="" style="width:200px;margin-top:200px"></div>
        <div>
          <img src="../assets/第一生命关于我们繁体_slices/人才招聘.png" alt="" style="width:100px;margin-left:50px;margin-top:10px">
        </div>
        </div>
      </div>
      <!-- 关于我们导航栏 公司概况 品质服务 企业荣誉 企业文化 -->
      <div style="display: flex; justify-content: center; align-items: center">
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 1200px;

            height: 400px;
          "
        >
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
            "
          >
            <div
              style="
                border-bottom: 1px solid grey;
                width: 120px;
                margin-left: 200px;
                display: flex;
                justify-content: center;
                height: 35px;
              "
            >
            招聘分類
            </div>
            <div style="margin-left: 260px">
              <input
                type="checkbox"
                id="option1"
                value="Option1"
                v-model="selectedOption"
              />
              <label for="option1" style="margin-left: 6px">全職</label>

              <input
                type="checkbox"
                id="option2"
                value="Option2"
                v-model="selectedOption"
                style="margin-left: 40px"
              />
              <label for="option2" style="margin-left: 6px"
                >兼職</label
              >
            </div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
            "
          >
            <div
              style="
                border-bottom: 1px solid grey;
                width: 120px;
                margin-left: 200px;
                display: flex;
                justify-content: center;
                height: 83px;
              "
            >
            工作類型
            </div>
            <div
              style="
                margin-left: 260px;
                display: flex;
                flex-direction: column;
                align-items: start;
              "
            >
              <div>
                <input
                  type="checkbox"
                  id="option1"
                  value="Option1"
                  v-model="selectedOption"
                />
                <label for="option1" style="margin-left: 6px">執業藥師</label>
              </div>

              <div style="margin-top: 20px">
                <input
                  type="checkbox"
                  id="option2"
                  value="Option2"
                  v-model="selectedOption"
                />
                <label for="option2" style="margin-left: 6px">采購員</label>
              </div>
            </div>
          </div>
          <el-button
            type="primary"
            style="
              width: 110px;
              height: 35px;
              font-size: 16px;
              border-radius: 0;
              margin-top: 35px;
              margin-left: 330px;
            "
            >提 交</el-button
          >
        </div>
      </div>
      <!-- footer -->
     <!-- footer -->
     <div
        class="footerBanner"
        style="
          width: 100%;
          height: 300px;

          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 100px;
        "
      >
        <div
          style="
            width: 1000px;
            height: 280px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div style="width:1000px;height:270px;background-color:rgba(254,254,254,0.65);margin-top:30px;display:flex">
         <div>
             <!-- 1 -->
             <div style="display: flex; align-items: center;margin-left:45px;margin-top:25px">
              <img
                src="../assets/香港首页繁体_slices/博爱logo.png"
                alt=""
                style="width:35px; height:32px"
              />
              <img
                src="../assets/香港首页繁体_slices/博爱香港有限公司(1).png"
                alt=""
                style="height: 17px; margin-left: 15px"
              />
            </div>
            <!-- 2 -->
            <div>
              <img src="../assets/香港首页繁体_slices/微笑面对每一位顾客，诚恳服务每一位顾客，从小事做起、从细节着手，用热心和耐心温暖顾客； 用诚心和爱心感动顾客；用心、尽心奉献于.png" alt="" style="width:560px;margin-left:45px;margin-top:28px">
            </div>
            <!-- 3 -->
            <div>
              <img src="../assets/香港首页繁体_slices/中国总公司： 营口博爱医药连锁有限公司：http：／／www.boaiyiyao.com  日本分公司： 株式会社政轩：htt.png" alt="" style="width:320px;margin-left:45px;margin-top:28px" >
            </div>
         </div>
         <div style="margin-left:240px;margin-top:115px;display:flex;align-items:center;flex-direction:column">
          <img src="../assets/香港首页繁体_slices/图层 19.png" alt="">
          <img src="../assets/香港首页繁体_slices/博爱公众号.png" alt="">
         </div>
          </div>
        </div>
      </div>
      <div style="width:100%;height:60px;background:#2C445C;display:flex;justify-content:center;align-items:center">
          <div style="width:1000px;height:40px;display:flex;align-items:center;justify-content:space-around;color:white">
          <div>首頁</div>
          <div>關于我們</div>
          <div>人才招聘</div>
          <div>聯系我們</div>
          </div>
      </div>
    </div>
    <div v-if="this.itemIndex == 5">
      <!-- banner -->
      <div class="top-rowBanner555555"></div>
      <!-- 关于我们导航栏 公司概况 品质服务 企业荣誉 企业文化 -->
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 60px 0;
        "
      >
        <div>お問い合わせ</div>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 1200px;
            border: 1px dashed grey;
            padding: 170px 0;
            height: 400px;
          "
        >
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              名前（姓名）
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              フリガナ（セイメイ）
            </div>
            <div
              style="
                width: 45px;
                height: 25px;

                display: flex;
                justify-content: center;
                align-items: center;
              "
            ></div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              会社名
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              お電話番号
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              メールアドレス
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              ご希望の連絡方法
            </div>
            <div
              style="
                width: 45px;
                height: 25px;

                display: flex;
                justify-content: center;
                align-items: center;
              "
            ></div>
            <div
              style="
                width: 340px;
                display: flex;
                justify-content: space-between;
              "
            >
              <div
                style="
                  width: 160px;
                  height: 30px;
                  border: 1px dashed grey;
                  background: #eef2f6;
                  line-height: 30px;
                "
              >
                <input
                  style="margin-left: 18px"
                  type="radio"
                  id="option1"
                  value="Option1"
                  v-model="selectedOption1"
                />
                <label for="option1" style="margin-left: 6px">メール</label>
              </div>
              <div
                style="
                  width: 160px;
                  height: 30px;
                  border: 1px dashed grey;
                  background: #eef2f6;
                  line-height: 30px;
                "
              >
                <input
                  style="margin-left: 18px"
                  type="radio"
                  id="option1"
                  value="Option1"
                  v-model="selectedOption1"
                />
                <label for="option1" style="margin-left: 6px">電話</label>
              </div>
            </div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;

              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              お問い合わせ内容
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 130px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 130px;
              background: #cf131c;
              padding: 10px 0;
              color: white;
              display: flex;
              justify-content: center;
              margin-left: 180px;
            "
          >
            送信
          </div>
        </div>
      </div>
      <!-- footer -->
      <div
        style="
          width: 100%;
          height: 300px;
          background: #eef2f6;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 100px;
        "
      >
        <div
          style="
            width: 1200px;
            height: 300px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div>
            <img
              src="../assets/首页_slices/logo.png"
              alt=""
              style="width: 220px"
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <img
              src="../assets/首页_slices/会社情報 事業内容 採用情報 お問い合わせ.png"
              alt=""
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <div>
              <img
                src="../assets/首页_slices/株式会社政轩.png"
                alt=""
                style="height: 25px"
              />
              <img
                src="../assets/首页_slices/Sei Ken Co,Ltd．.png"
                alt=""
                style="height: 16px; margin-left: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/福岡県福岡市中央区春吉３丁目21−21春野ビル５階E.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/中国本社： 营口博愛医薬连锁有限公司：http：／／www.boaiyiyao.com 香港支社： 博愛(香港)有限会社：ht.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedOption1: "",
      selectedOption: "",
      showtable: 1,
      itemIndex: 1,
      itemIndexAbout: 1,
      itemIndexVip: 1,
      itemIndexba: 1,
      itemIndexSup: 1,
      itemIndexzp: 1,
      labelPosition: "top",
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      selected:'FT',
      dialogVisible:true,
      options:[
        {
          text:"繁体中文",value:'FT'
        },
        {
          text:"日语",value:'RY'
        },
      ]
    };
  },

  methods: {
    handleRadioChange(value) {
      console.log('选中的值:', value);
      if(value=='FT'){
        this.$router.push('./');
        this.dialogVisible=false
        this.selected="RY"
      }
      if(value=='RY'){
        this.$router.push('./boaiRY');
        this.dialogVisible=false
        this.selected="FT"
      }
      // 在这里处理选择变化的事件
   
    },
    btnshowtable(index) {
      this.showtable = index;
    },
    btnClick(index) {
      this.itemIndex = index;
    },
    btnClickVip(index) {
      this.itemIndexVip = index;
    },
    btnClickba(index) {
      this.itemIndexba = index;
    },
    btnClickAbout(index) {
      this.itemIndexAbout = index;
    },
    btnClickSup(index) {
      this.itemIndexSup = index;
    },
    btnClickzp(index) {
      this.itemIndexzp = index;
    },
  },
};
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}
.nav {
  width: 1100px;
  height: 80px;
  /* background-color: rgb(159, 81, 81); */
  color: black;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.banner {
  height: 80px;
  background-color: rgb(245, 228, 228);
  color: black;
  display: flex;
  justify-content: space-between;
}
.center {
  list-style: none;

  /* background-color: pink; */
}
li {
  color: rgb(24, 5, 5);
  float: left;
}
a:hover {
  /* background-color: violet; */
  color: #246ef6;
  text-decoration: underline;
}
a {
  /* 
        一定注意要把a转成行内块元素，
        如果转的是块元素那么短竖线会掉下去，
        因为块级元素是独占一行的
    */
  display: inline-block;
  padding: 0 25px;
  line-height: 80px;
  text-decoration: none;
  color: black;
}

.top-rowBanner {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/香港首页繁体_slices/banner.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.footerBanner {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/香港首页繁体_slices/图层 18.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner1111 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/香港关于我们_slices/banner.png")
    no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner222222 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/lxwm.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner333333 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/banner1.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner444444 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/rczp.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner555555 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/日本官网-联系_slices/2.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner666 {
  background: #f8f8f8;
  /* padding: 3em 0 4em 0; */
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/cjx.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 260px;
}
.contentUS {
  background: #f8f8f8;
  /* padding: 3em 0 4em 0; */
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/lxwm1.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 260px;
}
.top-rowBanner6666 {
  background: #f8f8f8;
  /* padding: 3em 0 4em 0; */
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/join.jpg") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
}
.top-rowBanner1 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/size.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  margin-top: 35px;
}
.top-rowBanner2 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/indexAbout.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.top-rowBannerAbout {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/1.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 100px;
  /* margin-top:35px; */
}
.top-rowBanner2222 {
  background: #f8f8f8;
  /* padding: 3em 0 4em 0; */
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: white no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 80px;
  border-bottom: 3px dotted grey;

  /* margin-top:35px; */
}
.top-rowBanner3 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/map.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 220px;
  /* margin-top:35px; */
}
.top-rowBanner5 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/bannerVip.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.top-rowBanner5555 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/supbanner.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.top-rowBanner6 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/join.jpg") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.top-rowBanner544444 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/badsj.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.togethter {
  background: #f8f8f8;
  padding: 1em 0 1em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/toge.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.active {
  color: #246ef6;
  text-decoration: underline;
}
.activeShowHos {
  background: #0077c3;
  color: white;
  padding: 10px;
  /* text-decoration: underline; */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 13px;
}
.activeAbout {
  color: #246ef6;
  text-decoration: underline;
}
</style>